const state = {
    // showModalChangePassword: false,
    showFormPermission: false,
    showFormPermissionViewMode: false,
    selectedPermission: {},
};

const getters = {
    getShowFormPermission(state){
        return state.showFormPermission;
    },
    getShowFormPermissionViewMode(state){
        return state.showFormPermissionViewMode;
    },
    getSelectedPermission(state){
        return state.selectedPermission;
    },
};

const mutations = {
    // setShowModalChangePassword(state, payload){
    //     state.showModalChangePassword = payload;
    // },
    setShowFormPermission(state, payload){
        state.showFormPermission = payload;
    },
    setShowFormPermissionViewMode(state, payload){
        state.showFormPermissionViewMode = payload;
    },
    setSelectedPermission(state, payload){
        state.selectedPermission = payload;
    },
};

const actions = {
    setShowFormPermission({commit}, payload){
        commit('setShowFormPermission', payload);
    },
    setShowFormPermissionViewMode({commit}, payload){
        commit('setShowFormPermissionViewMode', payload);
    },
    setSelectedPermission({commit}, payload){
        commit('setSelectedPermission', payload);
    },
};


export default {
    state,
    getters,
    mutations,
    actions
};